export const membershipRestrictions = [
    {
        "title": "Free Plan",
        "gameCount": 2,
        "playerCount": 50,
        "elementCount": 50,
        "blocked": [
            "prizepacks",
            "collections",
            "secretCodes",
            "lootKeys",
            "quests",
            "tradePortal",
            "momentum",
            "item_contribution",
            'item_lottery',
            "item_collectible",
            "pointOfSale",
            "collaborators"
        ]
    },
    {
        "title": "Pro Plan",
        "gameCount": 10,
        "playerCount": 200,
        "elementCount": 200,
        "blocked": [
            'quests',
            'lootKeys',
            'tradePortal',
            'momentum',
            'pointOfSale',
            'collaborators',
        ]
    },
    {
        "title": "Premium Plan",
        "gameCount": 10,
        "playerCount": 1000,
        "elementCount": Infinity,
        "blocked": []
    },
    {
        "title": "Enterprise Plan",
        "gameCount": Infinity,
        "playerCount": Infinity,
        "elementCount": Infinity,
        "blocked": []
    }
]

/**
 * Only games the user owns consume their plan's game allotment. Managers and
 * distributors are collaborators on someone else's game — that game is already
 * covered by the owner's plan and must not be charged to them a second time.
 *
 * This reads the `roles` array rather than the collapsed `role` string set in
 * App.jsx, because that string is just "first non-player role in the array" and
 * an appId can hold more than one manage role. Getting that collapse wrong here
 * would hand the user an uncapped game limit, so the array is the source of
 * truth and a missing array fails closed.
 */
export function countsTowardGameLimit(game) {
    if (!game) return false;
    if (Array.isArray(game.roles)) return game.roles.includes('owner');
    return game.role === 'owner';
}

/**
 * The number of games in a managing list that count against the plan limit.
 * Every game-limit check should count with this rather than the raw list
 * length, which includes games the user only collaborates on.
 */
export function countOwnedGames(managingList) {
    if (!managingList) return 0;
    return Object.values(managingList).filter(countsTowardGameLimit).length;
}

export function testMemberRestrictions(e) {
    const membership = e.membership;
    const memNum = membership.membership;
    const restrict = membershipRestrictions[memNum];
    let reasonArr = [];
    let newGame = {};

    // a count of 0 is a normal state now that collaborator games are exempt, so
    // this branch is chosen on the caller passing a count at all, not on it
    // being truthy.
    if (typeof e.gameCount === 'number') {
        const existingGameCount = e.gameCount;

        if (existingGameCount >= restrict.gameCount) {
            newGame.disabled = true;
            reasonArr.push('games');
        }
        newGame.disabledReason = reasonArr;
        return newGame;
    }
    
    const game = e.gameData;
    const gameIndex = e.gameIndex;
    const create = e.create;
    const element = e.element;
    newGame = {...game}
    if (!restrict) return newGame;
    
    // console.log(index);
    

    // test on "Games I Manage" list
    if (gameIndex && gameIndex > restrict.gameCount) {
        newGame.disabled = true;
        reasonArr.push('games');
    }

    if (element && restrict.blocked.includes(element)) {
        newGame.disabled = true;
        reasonArr.push(element);
    }

    // test game-specific restrictions

    if (game) {
        // test against playerCount
        if (create) {
            if (restrict.playerCount && game.playerCount >= restrict.playerCount) {
                newGame.disabled = true;
                reasonArr.push('players');
            }
        } else {
            if (restrict.playerCount && game.playerCount > restrict.playerCount) {
                newGame.disabled = true;
                reasonArr.push('players');
            }
        }

        // test against elementCount
        if (create) {
            if (restrict.elementCount && game.createdElementTotal >= restrict.elementCount) {
                newGame.disabled = true;
                reasonArr.push('elements');
            }
        } else {
            if (restrict.elementCount && game.createdElementTotal > restrict.elementCount) {
                newGame.disabled = true;
                reasonArr.push('elements');
            }
        }
    }

    if (reasonArr.length > 0) {
        newGame.disabledReason = reasonArr;
    }
    return newGame;
}
